import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  selectorInput: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '10px',
    },
  },
  option: {
    paddingLeft: '24px',
    paddingTop: '6px',
    paddingBottom: '6px',
  },
  dot: {
    marginRight: '10px',
  },
});
